import { render, staticRenderFns } from "./jabies.vue?vue&type=template&id=5105b8d8&"
import script from "./jabies.vue?vue&type=script&lang=js&"
export * from "./jabies.vue?vue&type=script&lang=js&"
import style0 from "./jabies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports